<footer class="footer pt-5">
  <div class="container">
    <div class="row footer-title-margin-bottom">
      <div class="col-lg-12">
        <h1 class="text-light">Important Disclaimer</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="text-light footer-disclaimer-margin-bottom" [innerHTML]="disclaimer"></div>
      </div>
    </div>
  </div>
</footer>
<!-- footer end -->

<!-- footer-alt start -->
<section class="footer-alt pt-3 pb-3">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <p class="copyright mb-0 text-light">
          © C.R. England All Rights Reserved | Version {{ version }}
        </p>
      </div>
    </div>
  </div>
</section>
<!-- footer-alt end -->
